import {ActivityDiff} from '../../../../models/cdx-activity';
import {TaskDetails} from '../../../../models/task-details';
import {Utils} from '../../../../utils/utils';
import { createReducer, on } from '@ngrx/store';
import {
  addCommentFailedTaskAction,
  addCommentStartTaskAction, addReplyFailedTaskAction,
  addReplyStartTaskAction, deleteAttachmentFailedTaskAction,
  deleteAttachmentStartTaskAction, deleteAttachmentSucceededTaskAction, deleteCommentFailedTaskAction,
  deleteCommentStartTaskAction, deleteReplyFailedTaskAction,
  deleteReplyStartTaskAction, loadAttachmentFailedTaskAction,
  loadAttachmentStartTaskAction,
  loadCommentFailedTaskAction, loadCommentSucceededTaskAction,
  loadCurrentActivityDiffFailedTaskAction,
  loadCurrentActivityDiffStartTaskAction,
  loadCurrentActivityDiffSucceededTaskAction,
  loadDetailsFailedTaskAction,
  loadDetailsStartAction,
  loadDetailsSucceededTaskAction, loadDisplayBlockSucceededTaskAction, loadHistoryFailedTaskAction,
  loadHistoryStartTaskAction, loadHistorySucceededTaskAction,
  loadTaskDetailsFailedTaskAction,
  loadTaskDetailsStartAction,
  loadMetaStartAction,
  loadTaskDetailsSucceededTaskAction, removeAllSucceededTaskAction, updateAttachmentFailedTaskAction,
  updateAttachmentStartTaskAction, updateAttachmentSucceededTaskAction,
  updateCommentFailedTaskAction,
  updateCommentStartTaskAction, updateReplyFailedTaskAction,
  updateReplyStartTaskAction, updateTokenTaskAction, uploadAttachmentFailedTaskAction,
  uploadAttachmentStartTaskAction, uploadAttachmentSucceededTaskAction,
  loadAssignationStartAction,
  loadAssignationSucceededAction,
  loadMetaFailedAction,
  loadMetaSucceededAction
} from '../../action/task/task-details.action';


export class TaskDetailsState {
  datas: TaskDetails;
  displayInfoBlock: boolean;
  loading: boolean;
  error: any;
  loadPdf: boolean;
}

export const CURRENT_TASK_INITIAL_STATE: TaskDetailsState = {
  datas: null,
  displayInfoBlock: false,
  loading: false,
  error: null,
  loadPdf: true
};


export const taskDetailsReducer = createReducer(
  CURRENT_TASK_INITIAL_STATE,
  on(loadDetailsStartAction,
    loadTaskDetailsStartAction,
    loadMetaStartAction,
    loadCurrentActivityDiffStartTaskAction,
    addCommentStartTaskAction,
    updateCommentStartTaskAction,
    deleteCommentStartTaskAction,
    addReplyStartTaskAction,
    updateReplyStartTaskAction,
    deleteReplyStartTaskAction,
    loadAttachmentStartTaskAction,
    loadHistoryStartTaskAction,
    uploadAttachmentStartTaskAction,
    deleteAttachmentStartTaskAction,
    updateAttachmentStartTaskAction,
    loadAssignationStartAction,
    (state) => ({
      ...state,
      loading: true,
      error: null,
    })
  ),
  on(loadDetailsSucceededTaskAction,
    (state,{payload}) => {
      const copyDetailsSucceeded = {
        ...state.datas,
        details: payload.details,
        comments: Utils.setCommentOrder(payload.comments),
        attachments: payload.attachments,
        activities: payload.activities,
        token: payload.details.token,
        loadPdf: true,
        currentActivityDiff: new ActivityDiff(),
        taskResponse: payload.taskResponse,
        subTasks: payload.subTasks,
        supervisorId:  payload.supervisorId
      };
      return {
        ...state,
        datas: copyDetailsSucceeded,
        loading: false,
        error: null,
      };
    }
  ),
  on(
    loadMetaSucceededAction,
    (state, {payload}) => ({
      ...state,
      datas: {
        ...state.datas,
        details: {
          ...state.datas.details,
          metadata: payload.details.metadata,
        },
      },
      loading: false,
      error: null,
    })
  ),
  on(loadTaskDetailsSucceededTaskAction,
    (state,{payload}) => {
      const copyTaskDetailsSucceeded = {
        ...state.datas,
        details: payload.details,
        loadPdf: payload.loadPdf
      };
      return {
        ...state,
        datas: copyTaskDetailsSucceeded,
        loading: false,
        error: null,
      };
    }
  ),
  on(loadCurrentActivityDiffSucceededTaskAction,
    (state,{payload}) => {
      const copyCurrentActivityDiffSucceeded = {
        ...state.datas,
        currentActivityDiff: payload.currentActivityDiff,
        loadPdf: false
      };
      return {
        ...state,
        datas: copyCurrentActivityDiffSucceeded,
        loading: false,
        error: null,
      };
    }
  ),
  on(loadDetailsFailedTaskAction,
    loadTaskDetailsFailedTaskAction,
    loadMetaFailedAction,
    loadCurrentActivityDiffFailedTaskAction,
    loadCommentFailedTaskAction,
    addCommentFailedTaskAction,
    updateCommentFailedTaskAction,
    deleteCommentFailedTaskAction,
    addReplyFailedTaskAction,
    updateReplyFailedTaskAction,
    deleteReplyFailedTaskAction,
    loadAttachmentFailedTaskAction,
    loadHistoryFailedTaskAction,
    uploadAttachmentFailedTaskAction,
    deleteAttachmentFailedTaskAction,
    updateAttachmentFailedTaskAction,
    (state, {error}) => ({
      ...state,
      loading: false,
      error,
    })
    ),
  on(loadHistorySucceededTaskAction,
    (state,{payload}) => {
      const copyLoadHistorySucceeded = {
        ...state.datas,
        activities: payload.activities,
      };
      return {
        ...state,
        datas: copyLoadHistorySucceeded,
        loading: false,
        error: null,
      };
    }),
  on(loadCommentSucceededTaskAction,
    (state,{payload}) => {
      const upsertComment = payload.comments[0];
      let foundCom = false;
      let commentss = state.datas.comments.map(comm => {
        if (comm.cdx_id === upsertComment.cdx_id) {
          foundCom = true;
          return upsertComment;
        }
        return comm;
      });
      if (!foundCom) {
        commentss = commentss.concat(upsertComment);
      }
      const copyLoadCommentSucceeded = {
        ...state.datas,
        comments: Utils.setCommentOrder(commentss),
      };
      return {
        ...state,
        datas: copyLoadCommentSucceeded,
        loading: false,
        error: null,
      };
  }),
  on(uploadAttachmentSucceededTaskAction,
   (state,{payload}) => {
      const copyUploadAttachmentSucceeded = {
        ...state.datas,
        attachments: state.datas.attachments ? state.datas.attachments.concat(payload.attachments) : payload.attachments,
      };
      return {
        ...state,
        datas: copyUploadAttachmentSucceeded,
        loading: false,
        error: null,
      };
    }
  ),
  on(deleteAttachmentSucceededTaskAction,
    (state,{payload}) =>    {
      const copyDeleteAttachmentSucceeded = {
        ...state.datas,
        attachments: state.datas.attachments.filter(att => att.cdx_id !== payload.attachments[0].cdx_id)
      };
      return {
        ...state,
        datas: copyDeleteAttachmentSucceeded,
        loading: false,
        error: null,
      };
    }
  ),
  on(updateAttachmentSucceededTaskAction,
    (state,{payload}) =>    {
        const toReplace = state.datas.attachments.map(att => att.cdx_id).indexOf(payload.attachments[0].cdx_id);
        const updated = payload.attachments[0];
        updated.cdx_thumbnail = state.datas.attachments[toReplace].cdx_thumbnail;
        state.datas.attachments.splice(toReplace, 1, updated);
        const copyUpdateAttachmentSucceeded = {
          ...state.datas,
          attachments: state.datas.attachments
        };
        return {
          ...state,
          datas: copyUpdateAttachmentSucceeded,
          loading: false,
          error: null,
        };
      }
    ),
  on(removeAllSucceededTaskAction,
    (state) => ({
      ...state,
      datas: null,
      displayInfoBlock: false,
      loading: false,
      error: null,
    })
    ),
  on(updateTokenTaskAction,
    (state,{payload}) =>  {
        state.datas.details.token = payload.token;
        const copyUpdateToken = {
          ...state,
          datas: state.datas
        };
        return copyUpdateToken;
      }
    ),
  on(loadDisplayBlockSucceededTaskAction,
      (state,{payload}) =>  {
        const copyLoadDisplayBlockSucceeded = {
          ...state,
          displayInfoBlock: payload.displayInfoBlock
        };
        return copyLoadDisplayBlockSucceeded;
      }
    ),
    on(
    loadAssignationSucceededAction,
    (state, {payload}) => ({
      ...state,
      datas: {
          ...state.datas,
          details : {
                  ...state.datas.details,
                  cdx_wkf :{
                    ...state.datas.details.cdx_wkf,
                    assignation: payload.details.cdx_wkf.assignation,
                  }  
            }
        ,
      },
      loading: false,
      error: null,
    })
  ),

)
